import React from 'react';
import I18n from 'app/i18n';
import BuyButton from 'app/components/shop/lootboxes/buy_button';
import {isGuest} from 'app/utils';
import {currencyItem} from 'app/utils/ShopItemPriceFormat';
import ShopLootboxInterface from 'app/interfaces/shop/ShopLootboxInterface';

interface Props {
    lootbox: ShopLootboxInterface
    currency: string
    owned: boolean
    openingInProgress: boolean
    disabled: boolean
    buyNow: boolean
    afterBuy: () => void
    hideQuickOpen: boolean
    onOpen: () => void
    onQuickOpen: () => void
}

const LootboxDetailsActions = ({
    lootbox,
    currency,
    owned,
    openingInProgress,
    disabled,
    buyNow,
    afterBuy,
    hideQuickOpen,
    onOpen,
    onQuickOpen
}: Props): React.ReactElement => {
    if (isGuest() || !owned && !openingInProgress) {
        return <div className="shop-item-detail__actions">
            <BuyButton
                {...lootbox}
                currency={currencyItem(currency)}
                lootboxOpeningProcess={openingInProgress}
                customText={I18n.t('buy')}
                buyNow={buyNow}
                afterBuy={afterBuy}
                show_loading={false}
                hidePrice
                className="shop-item-detail__btn"
                disabled={disabled || openingInProgress}
            />
        </div>;
    }

    return <div className="shop-item-detail__actions">
        <button
            type="button"
            className={`button-adaptive btn-open shop-item-detail__btn${
                openingInProgress ? ' button-adaptive_disable' : ''
            }`}
            disabled={disabled || openingInProgress}
            onClick={onOpen}
        >
            {I18n.t('open')}
        </button>
        {!hideQuickOpen && !openingInProgress && <button
            type="button"
            className="button-adaptive shop-item-detail__btn shop-item-detail__btn--ghost"
            disabled={disabled}
            onClick={onQuickOpen}
        >
            {I18n.t('shop.quick_open')}
        </button>}
    </div>;
};

export default LootboxDetailsActions;
